import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  duplicateEmployerJob,
} from '@yeshuman/sdk'
import { useState } from 'react'
import { Copy, Loader2 } from 'lucide-react'
import { toast } from 'sonner'

import type { QueryClient } from '@tanstack/react-query'

type JobDuplicateButtonProps = {
  opportunityId: string
  token: string | null
  queryClient: QueryClient
  onDuplicated?: (newOpportunityId: string) => void
  label?: string
}

export function JobDuplicateButton({
  opportunityId,
  token,
  queryClient,
  onDuplicated,
  label = 'Duplicate job',
}: JobDuplicateButtonProps) {
  const [busy, setBusy] = useState(false)

  const handleDuplicate = async () => {
    if (!token || busy) return
    setBusy(true)
    try {
      const created = await duplicateEmployerJob({ token, opportunityId, queryClient })
      toast.success('Job duplicated.')
      onDuplicated?.(created.id)
    } catch (e) {
      toast.error(e instanceof Error ? e.message : 'Could not duplicate job')
    } finally {
      setBusy(false)
    }
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghostToolbar"
          size="iconSm"
          disabled={busy || !token}
          aria-label={label}
          onClick={() => void handleDuplicate()}
        >
          {busy ? (
            <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
          ) : (
            <Copy className="h-4 w-4" aria-hidden />
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  )
}
